export const CodeEntry = {
  SignInButton: 'sign-in-button',
  ResendCodeButton: 'resend-code-button',
};
